var alignment_rtlignore_default = {
  "alignLeft": "z-0Uc",
  "textWrapNowrap": "X1tPc",
  "alignRight": "K-DPR",
  "alignCenter": "RyY9e",
  "sizeFullWidth": "FFTjt",
  "renderedInTable": "dJDrM",
  "sizeOriginal": "MCPA2",
  "sizeContent": "_2GHxu",
  "sizeSmall": "_6IOdL",
  "sizeSmallCenter": "n5P3j",
  "flex": "wG0-q",
  "LEFT": "zScIz",
  "CENTER": "_828P1",
  "RIGHT": "OhSUO",
  "AUTO": "XU0fI",
  "JUSTIFY": "xMbGx"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
